var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconModeOfTransportTube = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 3.75C16.3035 3.75 19.8375 7.0455 20.2162 11.25H21.75C22.164 11.25 22.5 11.586 22.5 12C22.5 12.3848 22.2105 12.702 21.8377 12.7448L21.75 12.75L20.2162 12.7507C19.8368 16.9552 16.3035 20.25 12 20.25C7.6965 20.25 4.1625 16.9552 3.78375 12.7507L2.25 12.75C1.836 12.75 1.5 12.414 1.5 12C1.5 11.6153 1.7895 11.2987 2.16225 11.2552L2.25 11.25H3.78375C4.1625 7.04475 7.6965 3.75 12 3.75ZM5.29125 12.7507C5.66475 16.1257 8.526 18.75 12 18.75C15.474 18.75 18.3352 16.125 18.7087 12.7507H5.29125ZM5.29125 11.25H18.7087C18.336 7.875 15.4747 5.25 12 5.25C8.52525 5.25 5.664 7.875 5.29125 11.25Z", fill: "black" }))),
        alt: 'Icon ModeOfTransportTube',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconModeOfTransportTube;
//# sourceMappingURL=index.js.map